module.exports = __webpack_public_path__ + "media/images/articles/manners/thumb-ecc5c80b19eae5e05db773ce70ab3638.png";